import {
    Box, Grid, Typography, Divider, useTheme, Container,
} from "@mui/material";
import { ReactTyped } from "react-typed";
import Aos from "aos";
import { useEffect } from "react";
import "aos/dist/aos.css";

const AppFeatures = () => {
    const theme = useTheme();

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <Box
            sx={{
                position: "relative",
                pt: 4,
                pb: { xs: 1, md: 4 },


                overflow: "hidden",
            }}
        >
            <Container maxWidth="lg">


                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,

                        filter: "blur(45px)",
                        pointerEvents: "none",
                        zIndex: 0,
                    }}
                />

                {/* CONTENT */}
                <Box sx={{ position: "relative", zIndex: 1 }}>
                    <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center">
                        {/* LEFT CONTENT */}
                        <Grid item xs={12} md={6}>
                            <Typography
                                sx={{
                                    fontSize: "13px",
                                    letterSpacing: "2px",
                                    fontWeight: 600,
                                    mb: 1,
                                    color: theme.palette.primary.main,
                                }}
                                data-aos="fade-right"
                            >
                                • ABOUT ARTHGYAN
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: { xs: "20px", sm: "28px", md: "40px" },
                                    fontWeight: 600,
                                    color: theme.palette.text.primary,
                                    position: "relative",
                                    display: "inline-block",
                                }}
                            >
                                Grow Your{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        fontWeight: 900,
                                        background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                        position: "relative",
                                        display: "inline-block",
                                        "&::after": {
                                            content: '""',
                                            position: "absolute",
                                            bottom: "-4px",
                                            left: 0,
                                            width: "100%",
                                            height: "2px",
                                            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                        }
                                    }}
                                >
                                    Wealth
                                </Box>{" "}

                                With Confidence
                            </Typography>

                            <Typography
                                variant="body1"
                                sx={{
                                    // fontSize: "16px",
                                    fontSize: { xs: "12px", sm: "14px", md: "16px" },
                                    mt: 1,
                                    color: "#555",
                                    lineHeight: 1.9,
                                    textAlign: "justify",
                                }}
                                data-aos="fade-up"
                            >


                                ArthGyan is your trusted financial platform—built exclusively for the government and public sector employees. It brings together investments, insurance, and banking into one seamless platform, simplifying every financial decision.
                                ArthGyan focuses on
                                simplifying wealth creation through a tech-driven, customer-first approach, combining financial
                                education with seamless investment access.
                                Rooted in trust, clarity, and discipline, ArthGyan empowers you to make smarter financial decisions and build long-term financial security.
                            </Typography>
                        </Grid>

                        {/* RIGHT IMAGE */}
                        <Grid item xs={12} md={6}>
                            <Box
                                data-aos="zoom-in"
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Box
                                    component="img"
                                    src="https://ik.imagekit.io/arthgyan/Arthgyan_Web/new%20emulator"
                                    alt="ArthGyan App Preview"
                                    sx={{
                                        width: "100%",
                                        maxWidth: "520px",
                                        height: "auto",
                                        transform: { xs: "none", md: "translateY(-10px)" },
                                        filter: `drop-shadow(
    0px 40px 80px ${theme.palette.primary.main}55
  )`,
                                    }}

                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default AppFeatures;
